import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { cartonOperationIdSchema } from "./carton-operation";

export const attachConsolidationCartons = {
  name: "attachConsolidationCartons" as const,
  mutates: true,
  input: z.object({
    consolidationId: consolidationIdFormat.schema,
    cartons: z
      .array(
        z.object({
          cartonId: cartonOperationIdSchema,
          revision: z.string().min(1),
        }),
      )
      .min(1)
      .max(100),
  }),
  output: z.object({ cartonIds: z.array(cartonOperationIdSchema) }),
};
